"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const moment_1 = __importDefault(require("moment"));
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_ui_datepicker_1 = __importDefault(require("react-native-ui-datepicker"));
const Colors_1 = __importDefault(require("../../../../assets/colors/Colors"));
const CustomText_1 = __importDefault(require("../../../../components/text/CustomText"));
const helpler_1 = require("../../../../utils/helpler");
const scale_1 = require("../../../../utils/scale");
var ja = require('dayjs/locale/ja');
const ModalDatePicker = (props) => {
    const { visible, onClose, onSelected } = props;
    const [date, setDate] = (0, react_1.useState)(new Date());
    return (react_1.default.createElement(react_native_1.Modal, { visible: visible, animationType: "fade", statusBarTranslucent: true, transparent: true, onRequestClose: onClose, onShow: () => {
            helpler_1.isWeb && document.body.classList.add("prevent-slice-modal");
        }, onDismiss: () => {
            helpler_1.isWeb && document.body.classList.remove("prevent-slice-modal");
        } },
        react_1.default.createElement(react_native_1.Pressable, { style: styles.viewContain, onPress: onClose },
            react_1.default.createElement(react_native_1.View, { style: styles.viewModal },
                react_1.default.createElement(react_native_ui_datepicker_1.default, { mode: "single", locale: ja, date: date, onChange: (params) => {
                        setDate(params.date);
                    }, maxDate: new Date(), headerButtonColor: '#007AFF', selectedItemColor: '#007AFF', headerTextStyle: styles.headerText, displayFullDays: true, calendarTextStyle: styles.text, selectedTextStyle: { ...styles.text, color: '#FFF' }, dayContainerStyle: {
                        width: (0, scale_1.scale)(36),
                        height: (0, scale_1.scale)(36),
                        borderRadius: 999,
                        justifyContent: 'center',
                        alignItems: 'center',
                        overflow: 'hidden'
                    } }),
                react_1.default.createElement(react_native_1.View, { style: styles.bottom },
                    react_1.default.createElement(CustomText_1.default, { style: [styles.bottomBtn, {
                                marginRight: (0, scale_1.scale)(24)
                            }
                        ], onPress: onClose }, "\u30AD\u30E3\u30F3\u30BB\u30EB"),
                    react_1.default.createElement(CustomText_1.default, { style: styles.bottomBtn, onPress: () => {
                            onSelected((0, moment_1.default)(date?.toString()).format('YYYY/MM/DD'));
                        } }, "\u5B8C\u4E86"))))));
};
exports.default = ModalDatePicker;
const styles = react_native_1.StyleSheet.create({
    viewModal: {
        width: (0, scale_1.scale)(343),
        padding: (0, scale_1.scale)(16),
        borderRadius: (0, scale_1.scale)(4),
        backgroundColor: "#FFFFFF",
    },
    viewContain: {
        flex: 1,
        alignItems: "center",
        justifyContent: 'center',
        backgroundColor: Colors_1.default.textHeaderOpacity60
    },
    headerText: {
        fontFamily: 'Hiragino Kaku Gothic ProN',
        fontWeight: '700',
        color: '#292A33',
        fontSize: (0, scale_1.moderateScale)(16),
        lineHeight: (0, scale_1.moderateScale)(24),
    },
    text: {
        fontFamily: 'Hiragino Kaku Gothic ProN',
        fontWeight: '300',
        color: '#292A33',
        fontSize: (0, scale_1.moderateScale)(14),
    },
    bottom: {
        marginTop: (0, scale_1.scale)(12),
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-end'
    },
    bottomBtn: {
        fontSize: (0, scale_1.moderateScale)(15),
        lineHeight: (0, scale_1.moderateScale)(22.5),
        color: '#007AFF'
    }
});
